import React from 'react';
import {
  Box,
  Divider,
  List,
  ListItem,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LANGUAGE } from '@src/constants';
import { useTranslation } from 'react-i18next';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import sanitizeHtml from 'sanitize-html';
import { formatNumberWithSuffix } from '@src/services/package';
import { VOUCHER_TYPE } from '@src/constants/voucher';

const PackageFeature = ({
  isMobile,
  pkg,
  isRow,
  optionsSelected,
  bestVoucher,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { featuresDescription = [], featuresTitle, customResource } = pkg || {};
  const renderTitle = () => {
    if (!featuresTitle || !isRow) return null;
    return (
      <Typography
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            language === LANGUAGE.VN
              ? featuresTitle?.[language]
              : featuresTitle?.[LANGUAGE.EN],
          ),
        }}
        className="title-text"
      />
    );
  };
  const getMinValue = (key) => customResource?.[key]?.min;
  const getLocalizedText = (minValue, value) => {
    if (!value) {
      return minValue;
    }
    return `${minValue} + ${value}`;
  };
  const getCreditsWithBestVoucher = (credits) => {
    if (bestVoucher?.type === VOUCHER_TYPE.CHARACTER)
      return bestVoucher?.value * credits;

    if (bestVoucher?.type === VOUCHER_TYPE.FIXED_CHARACTER)
      return Number(bestVoucher?.value) + Number(credits);

    return credits;
  };
  const renderFeatureItem = (item, index) => {
    const localizedText = item[language];
    const advanced = item?.advanced;
    const comingSoon = item?.comingSoon;
    const tooltipText = item?.tooltip ? item.tooltip[language] || '' : '';

    return (
      <Box display="flex" justifyContent="space-between" key={item.vi || index}>
        <ListItem className="clarify">
          <Box style={{ width: '100%' }} className="flexItem">
            <div className="flexItem">
              <div className="icon-contents">
                {/* <Check
                  fontSize="small"
                  className={
                    advanced
                      ? 'check-icon coming-soon-text-advanced'
                      : 'check-icon'
                  }
                /> */}
                <FiberManualRecordRoundedIcon
                  fontSize="small"
                  className="dots"
                />
              </div>
              <span className="item-package">
                <div
                  className={
                    advanced
                      ? 'coming-soon-text-advanced content'
                      : 'coming-soon-text content'
                  }
                >
                  <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(
                        t(localizedText, {
                          credits: getLocalizedText(
                            formatNumberWithSuffix(
                              getCreditsWithBestVoucher(
                                optionsSelected?.credits,
                              ),
                              language,
                            ),
                          ),
                          devices: getLocalizedText(
                            getMinValue('devices'),
                            optionsSelected?.devices,
                          ),
                          voiceClonings: getLocalizedText(
                            getMinValue('voiceClonings'),
                            optionsSelected?.voiceClonings,
                          ),
                          concurrentRequestApi: getLocalizedText(
                            getMinValue('concurrentRequestApi'),
                            optionsSelected?.concurrentRequestApi,
                          ),
                        }),
                      ),
                    }}
                  />

                  {comingSoon && (
                    <span className="coming-soon-title">
                      ({t('comingSoon')})
                    </span>
                  )}
                </div>
              </span>
            </div>
            <div className="tooltip">
              {!isMobile && item?.tooltip && (
                <Tooltip
                  arrow
                  title={tooltipText}
                  placement="left"
                  className="tootlip"
                >
                  <InfoOutlinedIcon />
                </Tooltip>
              )}
            </div>
          </Box>
        </ListItem>
      </Box>
    );
  };

  const renderFeatureList = () => {
    if (!featuresDescription.length) return null;
    return (
      <List style={{ paddingTop: 0 }}>
        {featuresDescription.map((item, index) =>
          renderFeatureItem(item, index),
        )}
      </List>
    );
  };

  return (
    <>
      {renderFeatureList()}
      {featuresDescription.length > 0 && (
        <Divider className="divider-feature" />
      )}
      {renderTitle()}
    </>
  );
};

export default PackageFeature;
